import {
  absoluteImage,
  absoluteUrl,
  DEFAULT_SEO_PUBLISHER,
  stripHtml,
} from "../config/seo";

const truncate = (s: string, maxLen: number) => {
  const text = s.trim();
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}...`;
};

export const buildvivekvaniDescription = (vivekvani: any) => {
  const html = vivekvani?.description ?? vivekvani?.intro ?? "";
  const text = stripHtml(html);
  return truncate(text, 160);
};

export const buildvivekvaniKeywords = (vivekvani: any) => {
  const parts = [vivekvani?.author, vivekvani?.vivekvaniLanguage, vivekvani?.name]
    .map((v: any) => (v ? String(v).trim() : ""))
    .filter(Boolean);

  const uniq: string[] = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (!uniq.some((x) => x.toLowerCase() === key)) uniq.push(p);
  }

  return uniq.join(", ");
};

export const buildvivekvaniJsonLd = (vivekvani: any, canonicalPath: string) => {
  const url = absoluteUrl(canonicalPath);
  const seoImage = vivekvani?.ogImage || vivekvani?.vivekvaniPath || "";
  const image = seoImage ? absoluteImage(seoImage) : "";
  const description = buildvivekvaniDescription(vivekvani);
  const authorName = vivekvani?.author ? String(vivekvani.author).trim() : "";
  const name = vivekvani?.name ? String(vivekvani.name).trim() : "";
  const inLanguage = vivekvani?.vivekvaniLanguage ? String(vivekvani.vivekvaniLanguage).trim() : "";

  const jsonLd: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "vivekvani",
    name: name || undefined,
    url: url || undefined,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(authorName ? { author: { "@type": "Person", name: authorName } } : {}),
    ...(inLanguage ? { inLanguage } : {}),
    publisher: { "@type": "Organization", name: DEFAULT_SEO_PUBLISHER },
  };

  // Remove undefined properties so schema is cleaner.
  for (const key of Object.keys(jsonLd)) {
    if (jsonLd[key] === undefined) delete jsonLd[key];
  }

  return jsonLd;
};

